
/**
 * Debounce function
 * 
 * @param {function} targetFunction
 * @param {number} delay
 * 
 */
export default function (targetFunction, delay) {
  let timer;
  return function () { // Closure function
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      // Call the getData function
      // apply() function is used to pass the arguments
      targetFunction.apply(context, args);
    }, delay);
  }
}